import React, { FC } from 'react';
import { InputNumber, Select, Space, Switch, Typography, Upload } from 'antd';
import styled from 'styled-components';
import { PlusOutlined } from '@ant-design/icons';

import { TimePickerFormik } from 'shared/ui/Form/Fields/TimePickerFormik';
import { validateImages } from 'utils/common/validateImages';
import { TextEditor } from 'shared/ui/TextEditor/TextEditor';

import { RatePeriodEnum } from '../../../../interfaces/reputation.interface';
import { ReputationSwitchesEnum } from '../../ReputationMapper';

interface IProps {
    imgRef: React.MutableRefObject<any>;
    formik: any;
    img: any;
}

export const UserRateSwitch: FC<IProps> = props => {
    return (
        <StyledSpace align='start' size='small'>
            <StyledSwitch
                checked={
                    props.formik.values.switches[
                        ReputationSwitchesEnum.userRateSwitch
                    ].isChecked
                }
                onChange={value => {
                    props.formik.setFieldValue(
                        `switches.${ReputationSwitchesEnum.userRateSwitch}.isChecked`,
                        value
                    );
                    props.formik.setFieldValue(
                        `switches.${ReputationSwitchesEnum.userRateSwitch}.show_rating_tables`,
                        value
                    );
                }}
            />
            <Space direction='vertical'>
                <StyledTitle level={5}>Рейтинг пользователей</StyledTitle>
                {props.formik.values.switches[
                    ReputationSwitchesEnum.userRateSwitch
                ].isChecked && (
                    <>
                        <div style={{ display: 'flex' }}>
                            <div>
                                <div>Повтор</div>
                                <Select
                                    value={
                                        props.formik.values.switches[
                                            ReputationSwitchesEnum
                                                .userRateSwitch
                                        ]?.show_rating_tables_period
                                    }
                                    onChange={value => {
                                        props.formik.setFieldValue(
                                            `switches.${ReputationSwitchesEnum.userRateSwitch}.show_rating_tables_period`,
                                            value
                                        );
                                    }}
                                    style={{ minWidth: 150 }}
                                    options={[
                                        {
                                            value: RatePeriodEnum.first_day_of_week,
                                            label: 'раз в неделю',
                                        },
                                        {
                                            value: RatePeriodEnum.first_day_of_month,
                                            label: 'раз в месяц',
                                        },
                                        {
                                            value: RatePeriodEnum.first_day_of_year,
                                            label: 'раз в год',
                                        },
                                    ]}
                                />
                            </div>
                            <div style={{ marginLeft: 12 }}>
                                <div>Время оповещения</div>
                                <TimePickerFormik
                                    formik={props.formik}
                                    fieldName={`switches.${ReputationSwitchesEnum.userRateSwitch}.show_rating_tables_time`}
                                />
                            </div>
                        </div>
                        <div>
                            <div>Количество пользователей в рейтинге</div>
                            <InputNumber
                                value={
                                    props.formik.values.switches[
                                        ReputationSwitchesEnum.userRateSwitch
                                    ]?.show_rating_tables_number_of_users
                                }
                                onChange={value => {
                                    props.formik.setFieldValue(
                                        `switches.${ReputationSwitchesEnum.userRateSwitch}.show_rating_tables_number_of_users`,
                                        +value
                                    );
                                }}
                            />
                        </div>
                        <div>
                            <div>Текст оповещения</div>
                            <div style={{ display: 'flex' }}>
                                <div style={{ marginTop: 10 }}>
                                    <Upload
                                        maxCount={1}
                                        listType='picture-card'
                                        className='avatar-uploader'
                                        showUploadList={false}
                                        beforeUpload={() => false}
                                        onChange={value => {
                                            if (validateImages(value.file)) {
                                                props.imgRef.current =
                                                    value.file;
                                                props.formik.setFieldValue(
                                                    `switches.${ReputationSwitchesEnum.userRateSwitch}.show_rating_tables_image`,
                                                    value.file
                                                );
                                            }
                                        }}
                                    >
                                        {props.formik.values.switches[
                                            ReputationSwitchesEnum
                                                .userRateSwitch
                                        ]?.show_rating_tables_image ? (
                                            <StyledImage
                                                src={props.img}
                                                alt={'alt'}
                                            />
                                        ) : (
                                            <div>
                                                <PlusOutlined />
                                                <div style={{ marginTop: 8 }}>
                                                    Картинка
                                                </div>
                                            </div>
                                        )}
                                    </Upload>
                                </div>
                                <StyledEditorWrapper>
                                    <TextEditor
                                        containerHeight={164}
                                        value={
                                            props.formik.values.switches[
                                                ReputationSwitchesEnum
                                                    .userRateSwitch
                                            ]?.show_rating_tables_message
                                        }
                                        onChange={value => {
                                            props.formik.setFieldValue(
                                                `switches.${ReputationSwitchesEnum.userRateSwitch}.show_rating_tables_message`,
                                                value
                                            );
                                        }}
                                    />
                                </StyledEditorWrapper>
                            </div>
                        </div>
                    </>
                )}
            </Space>
        </StyledSpace>
    );
};

const StyledImage = styled.img`
    position: static;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const StyledTitle = styled(Typography.Title)`
    margin-block-start: 0;
    margin-block-end: 0;
    margin-bottom: 0 !important;
`;

const StyledSwitch = styled(Switch)`
    margin-right: 16px;
`;

const StyledSpace = styled(Space)`
    margin-bottom: 32px;
`;

const StyledEditorWrapper = styled.div`
    width: 600px;
    margin-top: 9px;
`;
